import React, { useEffect, useState } from "react";
import {
  collection, getDocs, doc, updateDoc, addDoc, deleteDoc, query, orderBy
} from "firebase/firestore";
import { db, storage } from "./firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import ReactMarkdown from "react-markdown";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import TurndownService from "turndown";
import { marked } from "marked";
import "./index.css";

const turndownService = new TurndownService();

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    ["clean"],
  ],
};

const formats = [
  "header", "bold", "italic", "underline", "list", "bullet", "link", "image"
];

function Noticias() {
  const [newsData, setNewsData] = useState([]);
  const [error, setError] = useState("");
  const [selected, setSelected] = useState(null);
  const [editing, setEditing] = useState(false);
  const [title, setTitle] = useState("");
  const [htmlContent, setHtmlContent] = useState("");
  const [newCreatedDate, setNewCreatedDate] = useState("");

  const [newBanner, setNewBanner] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);

  const [bannerQuadrado, setBannerQuadrado] = useState(null);
  const [bannerQuadradoPreview, setBannerQuadradoPreview] = useState(null);

  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const q = query(collection(db, "noticias"), orderBy("created_time", "desc"));
        const snapshot = await getDocs(q);
        setNewsData(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch {
        setError("Erro ao sincronizar os dados das notícias.");
      }
    };
    fetchData();
  }, []);

  const startEditing = (item) => {
    setSelected(item);
    setEditing(false);
    setTitle(item.title || "");
    setHtmlContent(marked(item.text || ""));
    setBannerPreview(item.banner || null);
    setBannerQuadradoPreview(item.banner_quadrado || null);
    setNewCreatedDate(
      item.created_time
        ? item.created_time.seconds
          ? new Date(item.created_time.seconds * 1000).toISOString().slice(0, 10)
          : new Date(item.created_time).toISOString().slice(0, 10)
        : ""
    );
  };

  const openEditing = () => setEditing(true);

  const saveText = async () => {
    if (!selected) return;

    const markdown = turndownService.turndown(htmlContent);

    let bannerURL = bannerPreview;
    if (newBanner) {
      const bannerRef = ref(storage, `noticias/${newBanner.name}`);
      await uploadBytes(bannerRef, newBanner);
      bannerURL = await getDownloadURL(bannerRef);
      setBannerPreview(bannerURL);
    }

    let bannerQuadradoURL = bannerQuadradoPreview;
    if (bannerQuadrado) {
      const bannerQuadradoRef = ref(storage, `noticias/quadrado/${bannerQuadrado.name}`);
      await uploadBytes(bannerQuadradoRef, bannerQuadrado);
      bannerQuadradoURL = await getDownloadURL(bannerQuadradoRef);
      setBannerQuadradoPreview(bannerQuadradoURL);
    }

    const docRef = doc(db, "noticias", selected.id);
    await updateDoc(docRef, {
      title,
      text: markdown,
      banner: bannerURL,
      banner_quadrado: bannerQuadradoURL,
      created_time: newCreatedDate ? new Date(newCreatedDate) : selected.created_time
    });

    setNewsData(prev =>
      prev.map(d =>
        d.id === selected.id
          ? {
              ...d,
              title,
              text: markdown,
              banner: bannerURL,
              banner_quadrado: bannerQuadradoURL,
              created_time: newCreatedDate ? new Date(newCreatedDate) : d.created_time
            }
          : d
      )
    );

    setSelected(prev => ({
      ...prev,
      title,
      text: markdown,
      banner: bannerURL,
      banner_quadrado: bannerQuadradoURL,
      created_time: newCreatedDate ? new Date(newCreatedDate) : prev.created_time
    }));

    setEditing(false);
    setNewBanner(null);
    setBannerQuadrado(null);
  };

  const deleteNews = async (id) => {
    if (!window.confirm("Tem certeza de que deseja excluir esta notícia da app?")) return;
    await deleteDoc(doc(db, "noticias", id));
    setNewsData(prev => prev.filter(d => d.id !== id));
    if (selected?.id === id) setSelected(null);
  };

  const filteredData = newsData.filter(item =>
    item.title?.toLowerCase().includes(search.toLowerCase())
  );

  const addNews = async () => {
    const newItem = {
      title: "",
      text: "",
      banner: "",
      banner_quadrado: "",
      created_time: new Date()
    };

    const docRef = await addDoc(collection(db, "noticias"), newItem);
    const itemWithId = { ...newItem, id: docRef.id };

    setNewsData(prev => [itemWithId, ...prev]);
    setSelected(itemWithId);
    setEditing(true);
    setTitle("");
    setHtmlContent("");
    setBannerPreview(null);
    setBannerQuadradoPreview(null);
    setNewBanner(null);
    setBannerQuadrado(null);
    setNewCreatedDate(new Date().toISOString().slice(0, 10));
  };

  if (error) return <p>{error}</p>;

  return (
    <div className="table-container">
      <div>
        <input
          type="text"
          placeholder="Procurar por título"
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="input"
        />
        <button className="btn btn-add" onClick={addNews}>
          Nova Notícia
        </button>
      </div>

      <div>
        {filteredData.length === 0 ? (
          <p style={{ textAlign: "center", color: "#292f2c" }}>Sem notícias</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Título</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map(item => (
                <tr key={item.id}>
                  <td>{item.title || "—"}</td>
                  <td>
                    <button className="btn btn-add" onClick={() => startEditing(item)}>Abrir</button>
                    <button className="btn btn-delete" onClick={() => deleteNews(item.id)}>Apagar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {selected && (
        <div className="drawer">
          <div className="drawer-content">
            <div>
              {editing ? (
                <input type="text" value={title} onChange={e => setTitle(e.target.value)} />
              ) : (
                <>
                  <strong style={{ fontSize: "20px" }}>{title || "—"}</strong>
                  <br /><br />
                </>
              )}

              <label>Data:</label>
              {editing ? (
                <input
                  type="date"
                  value={newCreatedDate}
                  onChange={e => setNewCreatedDate(e.target.value)}
                />
              ) : (
                <span>
                  {selected.created_time
                    ? selected.created_time.seconds
                      ? new Date(selected.created_time.seconds * 1000).toLocaleDateString()
                      : new Date(selected.created_time).toLocaleDateString()
                    : "—"}
                </span>
              )}

              <br /><br />

              {editing ? (
                <ReactQuill
                  theme="snow"
                  value={htmlContent}
                  onChange={setHtmlContent}
                  modules={modules}
                  formats={formats}
                  style={{ height: "400px", marginBottom: "50px" }}
                />
              ) : (
                <ReactMarkdown>{selected.text}</ReactMarkdown>
              )}

              {(bannerPreview || bannerQuadradoPreview) && (
                <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
                  {bannerPreview && (
                    <img
                      src={bannerPreview}
                      alt="Banner"
                      className="banner-noticia"
                    />
                  )}

                  {bannerQuadradoPreview && (
                    <img
                      src={bannerQuadradoPreview}
                      alt="Banner Quadrado"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover"
                      }}
                    />
                  )}
                </div>
              )}

              {editing && (
                <>
                  <label>Banner principal</label>
                  <input
                    type="file"
                    onChange={e => {
                      const file = e.target.files[0];
                      setNewBanner(file);
                      if (file) setBannerPreview(URL.createObjectURL(file));
                    }}
                  />

                  <label>Banner Quadrado</label>
                  <input
                    type="file"
                    onChange={e => {
                      const file = e.target.files[0];
                      setBannerQuadrado(file);
                      if (file) setBannerQuadradoPreview(URL.createObjectURL(file));
                    }}
                  />
                </>
              )}
            </div>
          </div>

          <div className="drawer-footer">
            {editing ? (
              <>
                <button className="btn btn-add" onClick={saveText}>Guardar</button>
                <button className="btn btn-cancel" onClick={() => setEditing(false)}>Cancelar</button>
                <button className="btn btn-cancel" onClick={() => setSelected(null)}>Fechar</button>
              </>
            ) : (
              <>
                <button className="btn btn-add" onClick={openEditing}>Editar</button>
                <button className="btn btn-cancel" onClick={() => setSelected(null)}>Fechar</button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Noticias;